import React from "react";
import wallet from "../../images/blockchain/empty-wallet-add.svg";
import users from "../../images/blockchain/ai-users.svg";
import network from "../../images/blockchain/status-up.svg";
import sheild from "../../images/blockchain/strongbox-2.svg";
const WalletSection = (props) => {
  // const [buttonText, setButtonText] = useState("View My Wallets");

  // // Handle Copy Button Click
  // const handleCopyClick = () => {
  //   const codeText = document.querySelector(".code mark").textContent;
  //   const textarea = document.createElement("textarea");
  //   document.body.appendChild(textarea);
  //   textarea.value = codeText;
  //   textarea.select();

  //   try {
  //     document.execCommand("copy");
  //     setButtonText("Copied!");

  //     // Reset text after 2 seconds
  //     setTimeout(() => {
  //       setButtonText("Copy");
  //     }, 2000);
  //   } catch (err) {
  //     console.error("Copy failed", err);
  //   }

  //   document.body.removeChild(textarea);
  // };

  return (
    <section
      id="id_memecoin_service_section"
      className={`memecoin_service_section  section_space z-2 pt-0 pb-5 position-relative ${props.tokenClass}`}
    >
      <div class="container">
        <div class="row justify-content-center">
          <div className="col-lg-8">
            <div className="px-4 py-4">
              <div className="mt-4">
                <h1 className=" text-white text-center opacity-75">
                  How to Understand the Value of Your TopCoin Rewards
                </h1>
                <p className="text-white text-center opacity-50">
                  TopCoin is a customer loyalty and promotional rewards
                  programme. When you shop at participating businesses, you
                  receive TopCoin as free promotional rewards. As you collect
                  more TopCoin higher reward levels unlock, giving you greater
                  promotional benefits.
                </p>
                <p className="text-white text-center opacity-50">
                  TopCoin rewards are not an investment, do not earn interest,
                  and do not depend on speculation or financial growth. They are
                  structured promotional rewards funded by participating
                  businesses as part of their advertising programme.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div className="text-center py-3">
            {" "}
            <h4>Step-by-Step Calculation</h4>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-6">
            <div className="card bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis">
                  1. Reward Value Allocation
                </h5>
                <ul className="mb-0 text-dark-emphasis">
                  <li>
                    Each TopCoin Cash reward Wallet contains a pre-funded
                    promotional reward amount
                  </li>
                  <li>
                    The value allocated to each TopCoin is determined by
                    dividing the wallet amount by the total number of TopCoin.
                  </li>
                  <li>
                    This is strictly a reward allocation, not an investment
                    return.
                  </li>
                </ul>
              </div>
            </div>
            <div className="card bg-white">
              <div className="card-body">
                <h5 className="text-dark-emphasis">
                  2. Calculate Your Total Rewards
                </h5>
                <ul className="mb-0 text-dark-emphasis">
                  <li>
                    {" "}
                    Once you know the TopCoin reward value, multiply it by the
                    number of TopCoin you have.
                  </li>
                  <li>
                    Repeat this for each reward wallet that you have unlocked.
                  </li>
                  <li>
                    Add the values from all unlocked wallets to understand your
                    total TopCoin promotional rewards.
                  </li>
                  <li>
                    {" "}
                    The reward value is calculated by dividing the promotional
                    wallet amount by the total number of TopCoin in the system.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="card bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis">
                  Example Calculation (Illustration Only)
                </h5>
                <ul className="mb-0 text-dark-emphasis">
                  <li>Promotional Wallet Value: £1,000</li>
                  <li>Total TopCoin 5,000</li>
                  <li>Reward Value per topcoin</li>
                  <li>£1,000 ÷ 5,000 = £0.20 (20p per TopCoin)</li>
                </ul>
              </div>
            </div>
            <div className="card bg-white">
              <div className="card-body">
                <ul className="mb-0 text-dark-emphasis">
                  <li>
                    {" "}
                    If you have 300 TopCoin and the promotional value per
                    topcoin is £0.20, then your reward from this wallet would
                    be: 300 × £0.20 = £60 promotional value
                  </li>
                  <li>
                    Repeat this for each unlocked wallet, then add the totals to
                    see your overall reward value.
                  </li>
                  <li>
                    Important Note:
                    <ul>
                      <li>
                        {" "}
                        TopCoin is a loyalty and promotional rewards programme,
                        not an investment.
                      </li>
                      <li>
                        Reward values relate to promotional wallet balances and
                        programme structure.
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-center mt-3">
          <div className="col-lg-8">
            <h4>Role of TopCoin UK </h4>
            <p >
              When you reach each milestone, the corresponding TopCoin reward
              level is unlocked.
            </p>
            <p>
              If you choose to redeem your rewards before reaching the next
              milestone, your reward will be based on the milestones you have
              already unlocked and the promotional structure of the programme.
            </p>
            <p>
              There is no investment activity, financial return, or interest involved. Rewards are purely promotional.
              </p>
          </div>
        </div>
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <div className="card bg-white min-h150">
                <div className="card-body  p-4">
                  <div className="d-flex gap-3 align-items-center">
                    <div className="icon-img">
                      <img src={wallet} width={24} alt="" />
                    </div>
                    <div className="text-dark opacity-75">
                      Each TopCoin UK Reward Wallet contains a pre-funded promotional reward amount.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="card bg-white min-h150">
                <div className="card-body p-4">
                  <div className="d-flex gap-3 align-items-center">
                    <div className="icon-img">
                      <img src={users} width={24} alt="" />
                    </div>
                    <div className="text-dark opacity-75">
                      Every TopCoin UK unit is securely recorded and traceable within the system.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="card bg-white min-h150">
                <div className="card-body p-4">
                  <div className="d-flex gap-3 justify-content-center align-items-center">
                    <div className="icon-img">
                      <img src={sheild} width={24} alt="" />
                    </div>
                    <div className="text-dark opacity-75">
                      Your unlocked rewards cannot be skipped. The secure system ensures your progress is always protected.
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="card bg-white min-h150">
                <div className="card-body p-4">
                  <div className="d-flex gap-3 align-items-center">
                    <div className="icon-img">
                      <img src={network} width={24} alt="" />
                    </div>
                    <div className="text-dark opacity-75">
                      Each business operates within its own secure rewards structure under the TopCoin UK network.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <p className="text-center mt-4">
          TopCoin UK is a loyalty and promotional rewards programme. It is not cryptocurrency, not an investment, and not a financial services product. No interest, profit, or speculative returns are provided.
        </p>
      </div>
    </section>
  );
};

export default WalletSection;
